import React, { useReducer, memo } from "react";
import clienteAxios from "../../config/axios";
import { OBTENER, EDITAR, CHANGE_ACTIVO, CREAR, ELIMINAR } from "../../types";

//context
import MenuContext from "./MenuContext";
//reducer
import MenuReducer from "./MenuReducer";
const MenuState = (props) => {
  const initialState = {
    rows: null,
    columns: [
      {
        id: "nombre",
        label: "nombre",
        minWidth: 150,
      },
      {
        id: "permisos",
        label: "permisos",
        minWidth: 150,
      },
      {
        id: "iconoIzquierda",
        label: "icono Izquierda",
        minWidth: 150,
      },
      {
        id: "iconoDerecha",
        label: "icono Derecha",
        minWidth: 150,
      },
      {
        id: "orden",
        label: "orden",
        minWidth: 50,
      },
    ],
    categoriaActiva: {
      sidId: 0,
      sidInfo: {
        orden: 1,
        mostrar: "NO",
        descripcion: "",
        path: "",
        name: "",
        icon: "",
        component: "",
        layout: "",
        tipo: "",
        ruta: false,
        expandible: true,
        permisos: ["USUARIO"],
        añadir: ["USUARIO"],
        editar: ["USUARIO"],
        ver: ["USUARIO"],
        eliminar: ["USUARIO"],
        impExp: ["USUARIO"],
        bloquearAreaDepartamento: "NO",
        tutoriales: [],
        areasDepartamento: [],
      },
    },
  };

  const [state, dispatch] = useReducer(MenuReducer, initialState);

  const obtenerCategorias = async () => {
    const res = await clienteAxios.get("/sidebar");
    console.log({ res });

    try {
      dispatch({
        type: OBTENER,
        payload: res.data.data,
      });
    } catch (error) {}
  };

  const editarCategoria = async (categoria) => {
    try {
      const res = await clienteAxios.put(`/sidebar/${categoria.sidId}`, {
        info: categoria.sidInfo,
      });

      dispatch({
        type: EDITAR,
        payload: categoria,
      });
      console.log({ res });
      return { error: false, msg: res.data.msg };
    } catch (error) {
      return { error: true, msg: "Hubo un error" };
    }
  };
  const crearCategoria = async (categoria) => {
    dispatch({
      type: CREAR,
      payload: categoria,
    });
  };
  const eliminarCategoria = async (id) => {
    dispatch({
      type: ELIMINAR,
      payload: id,
    });
  };

  const changeCategoriaActiva = (asignatura) => {
    dispatch({
      type: CHANGE_ACTIVO,
      payload: asignatura,
    });
  };
  const getPathToredirect = (component, withComponent) => {
    const itemFind = state.rows.find(
      (item) => item.sidInfo.component === component,
    );
    if (itemFind.sidInfo.tipo === "categoria") {
      return withComponent
        ? {
            component: itemFind,
            path: itemFind.sidInfo.layout + itemFind.sidInfo.path,
          }
        : itemFind.sidInfo.layout + itemFind.sidInfo.path;
    }
    if (itemFind.sidInfo.tipo === "subCategoria") {
      return withComponent
        ? {
            component: itemFind,
            path:
              itemFind.sidInfo.layout +
              itemFind.sidInfo.categoria +
              itemFind.sidInfo.path,
          }
        : itemFind.sidInfo.layout +
            itemFind.sidInfo.categoria +
            itemFind.sidInfo.path;
    }
    if (itemFind.sidInfo.tipo === "subsubCategoria") {
      // itemFind.sidInfo.subcategoria;
      // subCategoria.sidInfo.path;
      const subcategoria = state.rows.find(
        (item) => item.sidInfo.path === itemFind.sidInfo.subcategoria,
      );
      const categoria = state.rows.find(
        (item) => item.sidInfo.path === subcategoria.sidInfo.categoria,
      );

      return withComponent
        ? {
            component: itemFind,
            path:
              itemFind.sidInfo.layout +
              categoria.sidInfo.path +
              itemFind.sidInfo.subcategoria +
              itemFind.sidInfo.path,
          }
        : itemFind.sidInfo.layout +
            categoria.sidInfo.path +
            itemFind.sidInfo.subcategoria +
            itemFind.sidInfo.path;
    }
    if (itemFind.sidInfo.tipo === "sub_sub_subCategoria") {
      // itemFind.sidInfo.subcategoria;
      // subCategoria.sidInfo.path;
      const subsubcategoria = state.rows.find(
        (item) => item.sidInfo.path === itemFind.sidInfo.subsubCategoria,
      );
      const subcategoria = state.rows.find(
        (item) => item.sidInfo.path === subsubcategoria.sidInfo.subcategoria,
      );

      const categoria = state.rows.find(
        (item) => item.sidInfo.path === subcategoria.sidInfo.categoria,
      );

      return withComponent
        ? {
            component: itemFind,
            path:
              itemFind.sidInfo.layout +
              categoria.sidInfo.path +
              subsubcategoria.sidInfo.path +
              itemFind.sidInfo.subsubCategoria +
              itemFind.sidInfo.path,
          }
        : itemFind.sidInfo.layout +
            categoria.sidInfo.path +
            subcategoria.sidInfo.path +
            itemFind.sidInfo.subsubCategoria +
            itemFind.sidInfo.path;
    }

    // sidInfo.component
  };
  return (
    <MenuContext.Provider
      value={{
        //state
        rows: state.rows,
        columns: state.columns,
        categoriaActiva: state.categoriaActiva,
        // funciones
        obtenerCategorias,
        editarCategoria,
        changeCategoriaActiva,
        getPathToredirect,
        crearCategoria,
        eliminarCategoria,
      }}
    >
      {props.children}
    </MenuContext.Provider>
  );
};

export default memo(MenuState);
